import { useState } from "react";
import { Play } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";

const VIDEO_ID = "LBrowwc6BBI";
const THUMB = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`;

export default function VideoPresentation() {
  const [playing, setPlaying] = useState(false);

  return (
    <section className="bg-brand-blue py-24 lg:py-32" data-testid="video-presentation">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <SectionHeading
          eyebrow="En vidéo"
          title="Découvrez le groupe, ses centres et ses métiers"
          light
        />

        <Reveal>
          <div className="relative mt-12 aspect-video overflow-hidden rounded-3xl bg-black shadow-[0_30px_80px_-20px_rgba(227,0,15,0.4)]">
            {playing ? (
              <iframe
                className="absolute inset-0 h-full w-full"
                src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
                title="Présentation EDUCASER GROUP"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                data-testid="video-presentation-iframe"
              />
            ) : (
              <button
                onClick={() => setPlaying(true)}
                className="group absolute inset-0 h-full w-full"
                aria-label="Lire la vidéo de présentation"
                data-testid="video-presentation-play"
              >
                <img
                  src={THUMB}
                  alt="Présentation EDUCASER GROUP — centres et métiers"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-brand-blue/70 via-brand-blue/10 to-transparent" />
                <span className="absolute left-1/2 top-1/2 flex h-20 w-20 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-brand-red text-white shadow-[0_10px_40px_rgba(227,0,15,0.6)] transition-transform duration-300 group-hover:scale-110 sm:h-24 sm:w-24">
                  <Play className="ml-1 h-9 w-9 fill-current sm:h-10 sm:w-10" />
                </span>
              </button>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
